import { render, staticRenderFns } from "./LanguageSelectModal.vue?vue&type=template&id=1b7d9dc6&scoped=true&"
import script from "./LanguageSelectModal.vue?vue&type=script&lang=js&"
export * from "./LanguageSelectModal.vue?vue&type=script&lang=js&"
import style0 from "./LanguageSelectModal.vue?vue&type=style&index=0&id=1b7d9dc6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7d9dc6",
  null
  
)

export default component.exports